import { StreamLanguage } from '@codemirror/language';
import type { StreamParser } from '@codemirror/language';

const zetaStreamParser: StreamParser<{ inString: boolean }> = {
  startState() {
    return { inString: false };
  },

  token(stream, state) {
    if (stream.eatSpace()) return null;

    if (state.inString) {
      if (stream.match(/^[^}]+/)) return 'string';
      if (stream.eat('}')) {
        state.inString = false;
        return 'string';
      }
      stream.next();
      return 'string';
    }

    if (stream.match('<<')) {
      stream.skipTo('>>');
      stream.match('>>');
      return 'comment';
    }

    if (stream.match('<')) {
      stream.skipToEnd();
      return 'comment';
    }

    if (stream.eat('{')) {
      state.inString = true;
      return 'string';
    }

    if (stream.match(/^(global|local|tell|ask|is|now|true|false)\b/)) {
      return 'keyword';
    }

    if (stream.match(/^[+\-*/%^()]/)) {
      return 'operator';
    }

    if (stream.match(/^[+-]?(\d+\.\d+|\.\d+|\d+)/)) {
      return 'number';
    }

    if (stream.match(/^[a-zA-Z_][a-zA-Z0-9_]*/)) {
      return 'variable';
    }

    stream.next();
    return null;
  },
};

export const zetaLanguage = StreamLanguage.define(zetaStreamParser);
